var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 18,
    viewBox: "0 0 60 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.270429 1.21693C0.131648 0.592416 0.606868 0 1.24662 0H58.7534C59.3931 0 59.8684 0.592417 59.7296 1.21693L58 9L59.7296 16.7831C59.8684 17.4076 59.3931 18 58.7534 18H1.24662C0.606868 18 0.131648 17.4076 0.270429 16.7831L2 9L0.270429 1.21693Z",
    fill: "#FAB73B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountRectangle);
export default __webpack_public_path__ + "static/media/discount-rectangle.97b71d79a7dcb485bb5d517423e24e8b.svg";
export { ForwardRef as ReactComponent };